import { Directory } from "../../../domain/drawing";
import { FormatReference } from "../../../domain/format";
import { StringFilterParameter } from "../../system/filters";

export class FormatReferenceDirectoryFilterParameter {
  constructor(name: string = "") {
    this.name = new StringFilterParameter(name);
  }

  name: StringFilterParameter;

  filter(source: Directory<string, FormatReference>): boolean {
    return this.name.filter(source.name);
  }

  clone(): FormatReferenceDirectoryFilterParameter {
    return new FormatReferenceDirectoryFilterParameter(this.name.keyword);
  }
}
